/**
 * @module actions/uploads
 */
import { SET_UPLOADS, FINISH_UPLOADS } from '../constants'

export function setUploadsAction (uploads) {
  return {
    type: SET_UPLOADS,
    payload: uploads
  }
}

export const setUploads = uploads => dispatch => {
  dispatch(setUploadsAction(uploads))
}

export function finishUploadsIfAllDone () {
  return {
    type: FINISH_UPLOADS
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/uploads.js